import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUnits } from '../components/store/slices/settings/unitsSlice';
import { fromInputTemp, toDisplayTemp } from '../helpers/helpers';

/**
 * Temperatures are stored and sent in °C. Convert with `fromInput` where the
 * operator types and with `toDisplay` where a number is drawn.
 */
export const useTemperature = () => {
  const { isF } = useSelector(selectUnits);

  return useMemo(
    () => ({
      isF,
      unit: isF ? '°F' : '°C',
      toDisplay: (celsius) => toDisplayTemp(celsius, isF),
      fromInput: (value) => fromInputTemp(value, isF),
    }),
    [isF],
  );
};
